module.exports = __webpack_public_path__ + "static/img/mw.0ebce0f3.png";